<template>
  <panel title="Search">
    <v-text-field
      v-if="$store.state.user.role === 'Admin'"
      v-model="search"
      label="Search by User"
    />
  </panel>
</template>

<script>
import _ from 'lodash'

export default {
	data () {
		return {
			search: ''
		}
	},
	watch: {
		search: _.debounce(async function (value) {
			const route = {
				name: 'users'
			}
			if (this.search !== '') {
				route.query = {
					search: this.search
				}
			}
			this.$router.push(route)
		}, 700),
		'$route.query.search': {
			immediate: true,
			handler (value) {
				this.search = value
			}
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Users/UsersSearchPanel.vue